export class Step7 {
    constructor() {}

    intitule = 'stepper.form.diver.step7';

    getnoserviceexecutant = 'bloc_commun.divers.getnoserviceexecutant';
    getnumboncommande = 'bloc_commun.divers.getnumboncommande';
    getspan3 = 'bloc_commun.divers.getspan3';
    getregion = 'bloc_commun.divers.getregion';
    getdepartement = 'bloc_commun.divers.getdepartement';
    getetat = 'bloc_commun.divers.getetat';
    getdebiteuretranger = 'bloc_commun.divers.getdebiteuretranger';
    getdebiteurprivepersmorale = 'bloc_commun.divers.getdebiteurprivepersmorale';
    getdebiteurprivepersphysique = 'bloc_commun.divers.getdebiteurprivepersphysique';
    getgroupementcollectivites = 'bloc_commun.divers.getgroupementcollectivites';
    getcommune = 'bloc_commun.divers.getcommune';
    getautresorganismespublics = 'bloc_commun.divers.getautresorganismespublics';
    getetablissementspublicssante = 'bloc_commun.divers.getetablissementspublicssante';
    getsiret = 'bloc_commun.divers.getsiret';
    getdenomination = 'bloc_commun.divers.getdenomination';
    getadr1 = 'bloc_commun.divers.getadr1';
    getadr2 = 'bloc_commun.divers.getadr2';
    getadr3 = 'bloc_commun.divers.getadr3';
    getadr4 = 'bloc_commun.divers.getadr4';
    getcp = 'bloc_commun.divers.getcp';
    getlocalite = 'bloc_commun.divers.getlocalite';
    getpays = 'bloc_commun.divers.getpays';
    gettvaIntracommunautaire = 'bloc_commun.divers.gettvaIntracommunautaire';
    getnon = 'bloc_commun.divers.getnon';
    getoui = 'bloc_commun.divers.getoui';
    getville = 'bloc_commun.divers.getville';


}
